import { z } from "zod";

/** ULID em Crockford base32 (26 caracteres, sem I, L, O e U). */
export const ULID_PATTERN = /^[0-9A-HJKMNP-TV-Z]{26}$/;
export const ulidParam = z.string().regex(ULID_PATTERN, "Identificador inválido");
